export default "__VITE_ASSET__DLQXZKy1__"